import { Switch, useRouteMatch } from 'react-router';
import { PrivateRoute } from 'common/AuthRoute';
import React, { memo } from 'react';
import { BusinessPartnerPatientsPage } from 'pages/BusinessPartnerManagement/BusinessPartnerPatientsManagement/BusinessPartnerPatientsPage';
import { BusinessPartnerPatientPage } from 'pages/BusinessPartnerManagement/BusinessPartnerPatientsManagement/BusinessPartnerPatientPage';
import { BusinessPartnerRegisterPatientPage } from 'pages/BusinessPartnerManagement/BusinessPartnerPatientsManagement/BusinessPartnerRegisterPatientPage';
import { BusinessPartnerPatientsManagementRoutes } from 'pages/BusinessPartnerManagement/BusinessPartnerPatientsManagement/businessPartnerPatientsManagementRoutes';

export const BusinessPartnerPatientsManagement = memo(() => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <PrivateRoute exact path={path} component={BusinessPartnerPatientsPage} />
      <PrivateRoute
        exact
        path={`${path}/${BusinessPartnerPatientsManagementRoutes.Register}`}
        component={BusinessPartnerRegisterPatientPage}
      />
      <PrivateRoute
        exact
        path={`${path}/${BusinessPartnerPatientsManagementRoutes.Details}`}
        component={BusinessPartnerPatientPage}
      />
    </Switch>
  );
});
